export default class Storage {
  static set(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  }

  static get(key) {
    try {
      return JSON.parse(localStorage.getItem(key))
    } catch (err) {
      console.warn(`Could not parse JSON under ${key} at localStorage`)
      return null
    }
  }
}
window.Storage = Storage
